"use client";
import React from "react";
import Link from "next/link";
import { SingleProductDescriptionFocused } from "../singleProduct/singleProductDescriptionFocused";
import { SingleProductImageFocused } from "../singleProduct/singleProductImageFocused";
import { giftCardItem } from "@/utils/giftCardUtils";
import { ItemList } from "../itemList/itemList";
import { getItemUrl } from "@/utils/itemUrlUtils";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { ROUTE_GIFTCARD, ROUTE_RETAIL } from "@/utils/constants";
import { Layout } from "@/dto/item";

interface ItemsProps {
  itemTemplate?: string;
  items: any[];
  merchantName: string;
  layout?: Layout;
}

export const Items = ({
  itemTemplate,
  items,
  merchantName,
  layout = "default",
}: ItemsProps) => {
  return (
    <div className="pt-8">
      <ItemList listType={itemTemplate?.toLowerCase()} layout={layout}>
        {itemTemplate?.toLowerCase() === "image focused" &&
          items.map((product: any) => (
            <Link
              href={
                product.id !== giftCardItem.id
                  ? `${ROUTE_RETAIL}/${getItemUrl(product)}`
                  : ROUTE_GIFTCARD
              }
              key={product.id}
              data-testid={
                applyDataTestId(pom.landingPage.productLink) + product.id
              }
              prefetch={false}
            >
              <SingleProductImageFocused product={product} layout={layout} />
            </Link>
          ))}
        {itemTemplate?.toLowerCase() === "description focused" &&
          items.map((product: any) => (
            <Link
              href={
                product.id !== giftCardItem.id
                  ? `${ROUTE_RETAIL}/${getItemUrl(product)}`
                  : ROUTE_GIFTCARD
              }
              key={product.id}
              data-testid={
                applyDataTestId(pom.landingPage.productLink) + product.id
              }
              prefetch={false}
            >
              <SingleProductDescriptionFocused
                merchantName={merchantName}
                product={product}
                layout={layout}
              />
            </Link>
          ))}
      </ItemList>
    </div>
  );
};
